/** A menu item or option label with, while it can't be used, the reason under it. */
export function ItemWithReason({ label, reason }: { label: string; reason: string | undefined }) {
  return (
    <span className="flex flex-col">
      {label}
      {reason && <span className="paragraph-sm text-fg-muted">{reason}</span>}
    </span>
  )
}
